import {  gql } from '@apollo/client';

const RESEND_ACTIVATION_EMAIL_MUTATION = gql`
  mutation resendActivationEmail($projectId: String, $userId: Int!) {
    user {
      resendActivationEmail(email: $email, newEmail: $newEmail)
    }
  }
`;

export { RESEND_ACTIVATION_EMAIL_MUTATION };
